<template>
    <div>
        <div class="row" v-if="isLoading">
            <div class="col-12 text-center my-5">
                <div class="spinner-grow text-secondary tex" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div id="strategy-article-filters-container" class="col-md-3 pl-0">
                <site-article-strategy-filters
                    :initial-filters="filters"
                    :articles="strategyArticles"
                    :filter-icon="filterIcon"
                    @input="getFilteredArticles"
                ></site-article-strategy-filters>
            </div>

            <div
                v-if="articles.length > 0"
                id="strategy-article-list-container"
                class="news-list col-md-9 row pr-0"
            >
                <div class="feature-list col-12 row pr-0">
                    <div
                        v-for="article in articles"
                        :key="article.id"
                        class="col-lg-4 col-md-6 col-12 pr-0"
                    >
                        <site-article-strategy-item :article="article"></site-article-strategy-item>
                    </div>
                </div>

                <div class="ml-2 col">
                    <pagination
                        :total-pages="articlesPerPage"
                        :total="this.filteredStrategyArticles.length"
                        :per-page="perPage"
                        :current-page="currentPage"
                        @pagechanged="(page) => changePage(page)"
                    ></pagination>
                </div>
            </div>
            <div v-else id="no-results">{{ noArticlesLabel }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filterIcon: {
            type: String,
        },
    },
    data() {
        return {
            strategyArticles: [],
            filteredStrategyArticles: [],
            filters: [],
            perPage: 9,
            currentPage: 1,
            isLoading: true,
        };
    },
    mounted() {
        this.getStrategyArticles();
    },
    computed: {
        endpoint() {
            let geoR = this.geo.replace('-', '/');
            return this.geo === 'gb'
                ? '/json-files/site-article-strategy.json'
                : `/${geoR}/json-files/site-article-strategy.json`;
        },
        articles() {
            let toTake = this.perPage * this.currentPage;
            let from = toTake - this.perPage;

            return this.filteredStrategyArticles.slice(from, toTake);
        },
        articlesPerPage() {
            return Math.ceil(this.filteredStrategyArticles.length / this.perPage);
        },
        geo() {
            return document.querySelector('[name="geo.region"]').content.toLowerCase();
        },
        noArticlesLabel() {
            return (
                window.translations.siteArticleStrategyFilter.no_articles_found ||
                'No Articles Found...'
            );
        },
    },
    methods: {
        /*
         * This function set the current page and scroll window to element #strategy-articles
         */
        changePage(page) {
            this.currentPage = page;
            this.ktagRerender();
            window.scrollTo({
                top:
                    window.pageYOffset +
                    document.getElementById('strategy-articles').getBoundingClientRect().top -
                    110,
            });
        },
        getStrategyArticles() {
            fetch(window.location.origin + this.endpoint)
                .then((response) => response.json())
                .then((data) => {
                    this.strategyArticles = data.articles;
                    this.filteredStrategyArticles = data.articles;
                    this.filters = data.filters;
                    this.isLoading = false;
                    this.ktagRerender();
                });
        },
        getFilteredArticles(input) {
            this.currentPage = 1;
            this.filteredStrategyArticles = input;
            this.ktagRerender();
        },
        ktagRerender() {
            setTimeout(() => {
                ktag.reRender();
            }, 500);
        },
    },
};
</script>
